import { Icons } from '@silverfort/sf-components';
import { FC } from 'react';
import MessagePage from '../Controls/GenericMessagePage/MessagePage';

const CloudFallback: FC = () => {
    const goHome = () => {
        window.location.href = '/';
    };

    return (
        <MessagePage
            icon={Icons.CloudOff}
            bigMsg="Partial Connection"
            smallMsgs={[
                'Could not connect you to cloud services at the moment.',
                'You can still use Silverfort without cloud abilities.'
            ]}
            buttonText="Back to home"
            onButtonClick={goHome}
        />
    );
};

export default CloudFallback;
